<template>
    <b-form-group
            class="c-text"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <b-input-group>
            <b-form-input
                    v-if="required"
                    type="text"
                    :readonly="readOnly"
                    :id="id"
                    :state="chkState(id)"
                    v-model="dataValue"
                    :placeholder="placeholder"
                    :autocomplete="autocomplete"></b-form-input>
            <b-form-input
                    v-else
                    type="text"
                    :id="id"
                    :readonly="readOnly"
                    v-model="dataValue"
                    :placeholder="placeholder"
                    :autocomplete="autocomplete"></b-form-input>
            <b-input-group-append>
                <b-button @click="onInitScanClick" class="btn btn-sm btn-edit">
                    {{Core.Definition.getDefinition('Lecture')}}
                </b-button>
            </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
            {{invalidFeedbackMessage}}
        </b-form-invalid-feedback>
        <ModalScan v-model="dataValue" ref="modalScan"></ModalScan>
    </b-form-group>
</template>

<script>
    import ModalScan from './ModalScan'

    export default {
        name: 'InputScanText',
        components: {
            ModalScan
        },
        props: {
            required: {
                type: Boolean,
                default: false
            },
            value: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            labelCols: {
                type: Number,
                default: 0
            },
            autocomplete: {
                type: String,
                default: ''
            },
            readOnly: {
                type: Boolean,
                default: false
            },
            invalidFeedbackMessage: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue(val) {
                this.$refs.modalScan.open = false
                this.$emit('input', val)
            }
        },
        mounted() {
            this.dataValue = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                dataValue: ''
            }
        },
        methods: {
            chkState(val) {
                if (this.form !== undefined && this.form[val] !== undefined) {
                    const field = this.form[val]
                    return !field.$dirty || !field.$invalid
                }
            },
            onInitScanClick() {
                this.$refs.modalScan.open = true
            }
        }
    }
</script>